import * as stateApi from "src/api/state";

export function useStateFilter(gstinRef) {
  let states = ref([]);
  let stateFilter = ref({});

  const initStateFilter = async () => {
    try {
      const response = await stateApi.index({
        params: {
          gstin: unref(gstinRef),
        },
      });

      states.value = response?.data?.data;

      stateFilter.value = useFilter({
        entities: states,
        entity: "state",
      });
    } catch (error) {
      console.error(error);
    }
  };

  onBeforeMount(initStateFilter);

  if (gstinRef) {
    watch(gstinRef, initStateFilter);
  }

  return {
    states,
    stateFilter,
  };
}
